import { supabase } from "../supabaseClient";
import { slugify } from "../utils/productUtils";

const BLOG_COLUMNS =
  "id, title, slug, excerpt, content, featured_image, published, created_at, updated_at";

export const getBlogPosts = async ({ includeUnpublished = false } = {}) => {
  let query = supabase
    .from("blog_posts")
    .select(BLOG_COLUMNS)
    .order("created_at", { ascending: false });

  if (!includeUnpublished) {
    query = query.eq("published", true);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data || [];
};

export const getBlogPost = async (id, { includeUnpublished = false } = {}) => {
  if (!id) {
    throw new Error("Missing blog post id.");
  }

  let query = supabase
    .from("blog_posts")
    .select(BLOG_COLUMNS)
    .eq("id", id);

  if (!includeUnpublished) {
    query = query.eq("published", true);
  }

  const { data, error } = await query.maybeSingle();

  if (error) {
    throw error;
  }

  return data;
};

export const createBlogPost = async (post) => {
  const payload = normalizeBlogPayload(post);

  const { data, error } = await supabase
    .from("blog_posts")
    .insert(payload)
    .select(BLOG_COLUMNS)
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateBlogPost = async (id, post) => {
  if (!id) {
    throw new Error("Missing blog post id.");
  }

  const payload = normalizeBlogPayload(post);

  const { data, error } = await supabase
    .from("blog_posts")
    .update(payload)
    .eq("id", id)
    .select(BLOG_COLUMNS)
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteBlogPost = async (id) => {
  if (!id) {
    throw new Error("Missing blog post id.");
  }

  const { error } = await supabase.from("blog_posts").delete().eq("id", id);

  if (error) {
    throw error;
  }

  return true;
};

const normalizeBlogPayload = (post = {}) => {
  const title = String(post.title || "").trim();
  const content = String(post.content || "").trim();

  if (!title) {
    throw new Error("Enter a blog title.");
  }

  if (!content) {
    throw new Error("Enter blog content.");
  }

  return {
    title,
    slug: String(post.slug || "").trim() || slugify(title),
    excerpt: String(post.excerpt || "").trim(),
    content,
    featured_image: String(post.featured_image || "").trim(),
    published: Boolean(post.published),
  };
};
